import React, { useRef, useEffect } from 'react';
import { usePrevious } from '../hooks';
// import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Divider, Modal, message } from 'antd';
import { OAuthButton } from './OAuthButton';
import SVG from 'react-inlinesvg';
import {
  MailOutlined,
  LoginOutlined,
  LockOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { LoadingSpinner } from './LoadingSpinner';
import app_params from '../../../config/params';
import { analytics } from '../modules/analytics';


const Signup = ({
  session,
  signup,
  computedMatch,
  sendSignupOAuthCode,
}) => {

  const formRef = useRef(null);

  // tracking on first time (empty array) page load
  useEffect(() => { analytics.trackView('/signup'), []}); // first time load

  const prevSession = usePrevious(session);
  useEffect(() => {
    if (typeof prevSession !== 'undefined' && typeof session !== 'undefined') {
      if (prevSession.status === 'running' && session.status === 'idle') {
        injectServerErrors(session.signupFormErrors);
      }
    }
  }, [session]);
  const injectServerErrors = (formErrors) => {
    formErrors.forEach((formError) => {
      const { message, field } = formError;
      formRef.current.setFields([
        { name: field, errors: [message] },
      ]);
    });
  };

  const onFinish = (values) => {
    const { device } = session;
    const { plan = '', promo = '' } = computedMatch.params;
    signup({ ...values, device, plan, promo});
  };

  // console.log('plan is', plan);

  const { plan } = computedMatch.params;
  const { status } = session;
  const isBusy = status === "running";

  let formHeader = "Create Your Account";
  if (plan === 'enterprise') {
    formHeader = 'Sign up with PageHits Enterprise';
  }
  else if (plan === 'pro') {
    formHeader = 'Sign up with PageHits Pro';
  }
  else if (plan === 'starter') {
    formHeader = 'Sign up with PageHits Starter';
  }

  return (
    <div className="auth__form_wrapper">

      <div className="auth__form_content">
        <h3>{formHeader}</h3>

        <Form onFinish={onFinish} className="auth-form" ref={formRef}>

          <Form.Item name="name" rules={[
            { required: true, message: 'Please enter your name!' },
          ]}>
            <Input type="text" disabled={isBusy} prefix={<UserOutlined />} placeholder="Full name" />
          </Form.Item>

          <Form.Item name="email" rules={[
            { required: true, message: 'Email cannot be blank!' },
          ]}>
            <Input disabled={isBusy} prefix={<MailOutlined />} placeholder="Work email" />
          </Form.Item>

          <Form.Item name="password" rules={[
            { required: true, message: 'Choose a password!' },
          ]}>
            <Input disabled={isBusy} prefix={<LockOutlined />} type="password" placeholder="Password" />
          </Form.Item>

          <div className="text-secondary mb-2 small" >
            By signing up, I agree to PageHits's <a href="https://www.pagehits.io/legal/terms" target="_blank">terms</a> &amp; <a href="https://www.pagehits.io/legal/privacy" target="_blank">privacy policy</a>.
          </div>

          <Form.Item>
            <Button
              block htmlType="submit" type="primary" size="large"
              icon={<LoginOutlined />} loading={isBusy}
            >
              Sign up now
            </Button>
          </Form.Item>

        </Form>

      </div>

      <div className="text-center">
        <span className="text-secondary">Signed up already?</span>
        <Link to="/login" className="ml-2">
          <span>Login</span>
        </Link>
      </div>

    </div>
  );


};

export { Signup };

//
// export class Signup extends React.Component {
//
//   constructor(props) {
//     super(props);
//     this.formRef = React.createRef();
//   }
//
//   static propTypes = {
//     session: PropTypes.shape({
//       isAuthenticated: PropTypes.bool.isRequired,
//       status: PropTypes.string.isRequired,
//       device: PropTypes.object,
//       signupFormErrors: PropTypes.array,
//     }).isRequired,
//     signup: PropTypes.func.isRequired,
//     computedMatch: PropTypes.object,
//     sendSignupOAuthCode: PropTypes.func.isRequired,
//   };
//
//   componentDidMount() {
//     analytics.trackView('/signup');
//   }
//
//   componentDidUpdate(prevProps) {
//     const { status: prevStatus } = prevProps.session;
//     const { status } = this.props.session;
//     if (prevStatus === 'running' && status === 'idle') {
//       this.injectServerErrors(this.props.session.signupFormErrors)
//     }
//   }
//
//   injectServerErrors = (formErrors) => {
//     formErrors.forEach((formError) => {
//       const { message, field } = formError;
//       this.formRef.current.setFields([
//         {
//           name: field,
//           errors: [message],
//         },
//       ]);
//     });
//   };
//
//
//   oAuthSignupClicked = (provider) => {
//     let auth_endpoint = null;
//     if (provider === "google") {
//       auth_endpoint = `${app_params.OAUTH.GOOGLE.AUTH_ENDPOINT}?scope=openid email profile&redirect_uri=${app_params.OAUTH.GOOGLE.REDIRECT_URI}&response_type=code&client_id=${app_params.OAUTH.GOOGLE.CLIENT_ID}&state=google`;
//     }
//     else if (provider === "facebook") {
//       auth_endpoint = `${app_params.OAUTH.FACEBOOK.AUTH_ENDPOINT}?scope=email&client_id=${app_params.OAUTH.FACEBOOK.CLIENT_ID}&redirect_uri=${app_params.OAUTH.FACEBOOK.REDIRECT_URI}&response_type=code&state=facebook`;
//     }
//     if (auth_endpoint === null) {
//       return;
//     }
//
//     try {
//       const left = (window.screen.width / 2) - (POPUP_WIDTH / 2);
//       const top = (window.screen.height / 2) - (POPUP_HEIGHT / 2);
//       const win = window.open(
//         auth_endpoint,
//         'Login to PageHits',
//         `menubar=no,location=no,resizable=no,scrollbars=no,status=no,width=${POPUP_WIDTH},height=${POPUP_HEIGHT},top=${top},left=${left}`
//       );
//       if (win) {
//         win.opener = window;
//         this.listenToMessageEvent();
//       }
//     }
//     catch (e) {
//       message.error("Could not open window. Are you sure you've allowed popups?");
//     }
//   };
//
//
//   listenToMessageEvent = () => {
//     const { device } = this.props.session;
//     const windowEventHandler = (event) => {
//       const hash = event.data;
//       if (hash.type === 'OAUTH_CODE_RECEIVED') {
//         const { code, provider } = hash;
//         this.props.sendSignupOAuthCode({
//           code,
//           device,
//           provider,
//           state: provider,
//           scope: (provider === 'google') ? 'openid email profile' : 'email'
//         });
//       }
//       else if (hash.type === 'OAUTH_CODE_ERROR') {
//         message.warning(hash.message);
//       }
//       window.removeEventListener('message', windowEventHandler);
//     };
//     window.addEventListener('message', windowEventHandler, false);
//   }
//
//
//   onFinish = (values) => {
//     // eventGA({ category: 'authentication', action: 'signup' });
//     const { device } = this.props.session;
//     const plan = this.props.computedMatch.params.plan ? `plan_${this.props.computedMatch.params.plan}` : "";
//     const promo = this.props.computedMatch.params.promo ? this.props.computedMatch.params.promo : '';
//     this.props.signup({ ...values, device, plan, promo });
//   };
//
//   render() {
//     const { plan } = this.props.computedMatch.params;
//     const { session } = this.props;
//     const { status } = session;
//     const isBusy = status === "running";
//
//     let formHeader = "Create Your Account";
//     if (plan === 'enterprise') {
//       formHeader = 'Sign up with PageHits Enterprise';
//     }
//     else if (plan === 'pro') {
//       formHeader = 'Sign up with PageHits Pro';
//     }
//     else if (plan === 'starter') {
//       formHeader = 'Sign up with PageHits Starter';
//     }
//
//     const oAuthBusyModal = (
//       <Modal
//         title={null} visible={status === 'oauth_running'}
//         onOk={null}
//         onCancel={null}
//         mask={true} maskClosable={false}
//         destroyOnClose={true} footer={null} header={null}
//         closable={false} centered
//       >
//         <div className="text-center">
//           <h5 className="my-3 text-secondary">Fetching account information</h5>
//           <LoadingSpinner />
//         </div>
//       </Modal>
//     );
//
//
//     return (
//       <div className="auth__form_wrapper">
//
//         <div className="auth__form_content">
//           <h3>{formHeader}</h3>
//
//           <Form onFinish={this.onFinish} className="auth-form" ref={this.formRef}>
//
//             <Form.Item name="name" rules={[
//               { required: true, message: 'Please enter your name!' },
//             ]}>
//               <Input type="text" disabled={isBusy} prefix={<UserOutlined />} placeholder="Full name" />
//             </Form.Item>
//
//             <Form.Item name="email" rules={[
//               { required: true, message: 'Email cannot be blank!' },
//             ]}>
//               <Input disabled={isBusy} prefix={<MailOutlined />} placeholder="Work email" />
//             </Form.Item>
//
//             <Form.Item name="password" rules={[
//               { required: true, message: 'Choose a password!' },
//             ]}>
//               <Input disabled={isBusy} prefix={<LockOutlined />} type="password" placeholder="Password" />
//             </Form.Item>
//
//             <div className="text-secondary mb-2 small" >
//               By signing up, I agree to PageHits's <a href="https://www.pagehits.io/legal/terms" target="_blank">terms</a> &amp; <a href="https://www.pagehits.io/legal/privacy" target="_blank">privacy policy</a>.
//             </div>
//
//             <Form.Item>
//               <Button
//                 block htmlType="submit" type="primary" size="large"
//                 icon={<LoginOutlined />} loading={isBusy}
//               >
//                 Sign up now
//               </Button>
//             </Form.Item>
//
//           </Form>
//
//         </div>
//
//         <div className="text-center">
//           <span className="text-secondary">Signed up already?</span>
//           <Link to="/login" className="ml-2">
//             <span>Login</span>
//           </Link>
//         </div>
//
//       </div>
//     );
//   }
// }


// <div className="text-center">
//   <Divider orientation="center" className="text-muted">or</Divider>
//
//   <OAuthButton provider="google" className="mb-2" title="Sign up with Google" onClick={()=> this.oAuthSignupClicked("google")} />
//   <OAuthButton provider="facebook" className="mb-2" title="Sign up with Facebook" onClick={()=> this.oAuthSignupClicked("facebook")} />
// </div>
// {oAuthBusyModal}



// WEBPACK FOOTER //
// ./scripts/presentation/Signup.jsx